import MembershipOpenInvoiceListResourceModel from '../../generated/types/model/resource/MembershipOpenInvoiceListResourceModel';

export default class MembershipOpenInvoiceListResourceViewModel extends MembershipOpenInvoiceListResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
